export default __webpack_public_path__ + "static/media/brittney2.f333141f.jpeg";